import type { FaqEntry } from '@/data/shared/faq';
import { getFaqGroups } from '@/data/shared/faqDirectory';

import type { LanguageType } from '@/types/language';

import { SolutionFaqItem } from '../solution/shared/SolutionFaqItem';
import FaqAskAi from './FaqAskAi';
import { trackFaqEvent } from './faqAnalytics';

export default function FaqDirectoryItem({
  locale,
  entry,
  groupId,
}: {
  locale: LanguageType;
  entry: FaqEntry;
  groupId: string;
}) {
  const entries =
    getFaqGroups(locale).find((group) => group.id === groupId)?.entries ?? [];
  const faqId = `${groupId}_${entries.findIndex((item) => item.question === entry.question) + 1}`;
  return (
    <SolutionFaqItem
      entry={entry}
      tone="light"
      onExpansionChange={(expanded) =>
        trackFaqEvent(
          expanded ? 'faq_answer_open' : 'faq_answer_close',
          locale,
          { faq_id: faqId, topic_id: groupId },
        )
      }
      followUp={
        <FaqAskAi
          locale={locale}
          entry={entry}
          groupId={groupId}
          faqId={faqId}
        />
      }
    />
  );
}
